import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import "./Login.css";

function formatError(detail) {
  if (!detail) return "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@netproprete.fr");
  const [password, setPassword] = useState("Admin1234!");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/dashboard" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim(), password);
      toast.success("Connexion réussie");
      navigate("/dashboard");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail) || err.message || "Connexion impossible");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="login-page">
      <section className="login-visual">
        <img
          src="https://images.unsplash.com/photo-1577412647305-991150c7d163?crop=entropy&cs=srgb&fm=jpg&q=85"
          alt="Bureaux professionnels"
          className="login-visual-image"
        />
        <div className="login-visual-overlay" />
        <div className="login-visual-content">
          <div className="login-brand">
            <img src="/net-proprete-logo.png" alt="Net Propreté" className="login-logo" />
            <span>Net Propreté</span>
          </div>

          <div className="login-hero-copy">
            <h1>SIRH dédié au<br />nettoyage professionnel.</h1>
            <p>Gérez vos salariés, contrats et affectations multi-sites en toute conformité RGPD.</p>
          </div>

          <div className="login-version">v1.0 — ÉDITION INTERNE</div>
        </div>
      </section>

      <section className="login-panel">
        <div className="login-form-wrap">
          <div className="login-mobile-brand">
            <img src="/net-proprete-logo.png" alt="Net Propreté" className="login-logo" />
            <strong>Net Propreté</strong>
          </div>

          <header className="login-header">
            <h2>Connexion</h2>
            <p>Accès au système de gestion RH</p>
          </header>

          <form onSubmit={onSubmit} className="login-form" data-testid="login-form">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              data-testid="login-email-input"
            />

            <label htmlFor="password">Mot de passe</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              data-testid="login-password-input"
            />

            <button type="submit" disabled={loading} data-testid="login-submit-btn">
              <Lock size={16} />
              {loading ? "Connexion…" : "Se connecter"}
            </button>
          </form>

          <div className="demo-accounts">
            <div className="demo-title">Comptes de démonstration</div>
            <div>Admin RH — admin@netproprete.fr / Admin1234!</div>
            <div>Manager — manager.nord@netproprete.fr / Manager1234!</div>
          </div>
        </div>
      </section>
    </main>
  );
}
